import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from 'src/app/services/auth/auth.service';

export const registroDisenoGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.validarDisenoRegistro().pipe(
    map((respuesta: any) => {
      const valor = Number(respuesta?.Respuesta?.valor || 0);

      if (valor === 1) {
        return true;
      }

      return router.createUrlTree(['/login'], {
        queryParams: {
          registro: 'legacy'
        }
      });
    }),
    catchError(() =>
      of(
        router.createUrlTree(['/login'], {
          queryParams: {
            registro: 'legacy'
          }
        })
      )
    )
  );
};